import { useTranslation } from 'react-i18next';
import LinkDrawer from '@/components/LinkDrawer';
import { useDeviceDimensions } from '@/hooks/useDeviceDimensions';
import { LinkModal } from '../LinkModal';

const PrivacyPolicyModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const { t } = useTranslation();
  const { isDesktopDimensions } = useDeviceDimensions();
  const privacyPolicyUrl = t('general.links.privacy-policy');

  return isDesktopDimensions ? (
    <LinkModal
      open={open}
      onClose={onClose}
      src={privacyPolicyUrl}
      title="Privacy Policy"
    />
  ) : (
    <LinkDrawer
      url={privacyPolicyUrl}
      title="Privacy Policy"
      isOpen={open}
      handleClose={onClose}
    />
  );
};

export { PrivacyPolicyModal };
